<script lang="ts">
	import { Helper, Select } from "flowbite-svelte-v1";
	import { getContext } from "svelte";
	import type { Poll } from "#gen/forms/v1/poll_pb.js";
	import type { User } from "#gen/identities/v1/identities_pb.js";
	import Label from "#lib/components/Label.svelte";
	import type { Writable } from "svelte/store";

	interface Props {
		poll: Poll;
		onChange?: (poll: Poll) => void;
	}

	const user: Writable<User> = getContext("user");
	const timezones = Intl.supportedValuesOf("timeZone");

	let { poll, onChange }: Props = $props();

	function handleTimezoneChange(e: Event) {
		const target = e.currentTarget as HTMLInputElement;
		onChange?.({ ...poll, timezone: target.value });
	}
</script>

<form class="flex w-full flex-col gap-4" onsubmit={e => e.preventDefault()}>
	<div class="flex w-full flex-col gap-4 rounded-lg border p-4">
		<div class="flex w-full flex-col gap-2 rounded-lg border p-4">
			<Label class="required text-sm font-medium text-gray-700">Timezone</Label>
			<Select value={poll.timezone || $user.timezone} placeholder={$user.timezone} id="timezones" onchange={handleTimezoneChange}>
				{#each timezones as timezone (timezone)}
					<option value={timezone}>{timezone}</option>
				{/each}
			</Select>
		</div>
		<Helper>Selected timezone will apply to all scheduling inputs.</Helper>
	</div>
</form>
